import Hero, { HERO_FRAGMENT } from '../../components/Hero';
import fetchGql, { gql } from '../../util/fetchGql';
import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import BrandContent, { BRAND_CONTENT_FRAGMENT } from '../../components/BrandContent';
import Products, { PRODUCTS_QUERY } from '../../components/Products';
import Heading from '../../components/Heading';
import NewsCard, { NEWS_CARD_FRAGMENT } from '../../components/NewsCard';
import Wrap from '../../components/Wrap';
import { FILTER_QUERY } from '../../components/Filter';

export const BRAND_QUERY = gql`
    query Brand ($slug: String) {
        entry (slug: [$slug]) {
            ... on brand_default_Entry {
                id
                title
                seo { ...Seo }
                hero: banner { ...Hero }
                hasProducts
                ...BrandContent
            }
        }
        news: entries (
            section: "post"
            relatedToEntries: [{ slug: [$slug] }]
        ) {
            ...NewsCard
        }
    }
    ${SEO_FRAGMENT}
    ${HERO_FRAGMENT}
    ${BRAND_CONTENT_FRAGMENT}
    ${NEWS_CARD_FRAGMENT}
`;

export default function Brand ({ entry: { id, title, seo, hero, hasProducts, ...brandContent }, filter, news, products }) {
	return (
		<>
			<Seo seo={seo} />
			<Hero
				black
				subHeading="Brand"
				{...hero[0]}
				containImage
			/>
			<BrandContent {...brandContent} hasProducts={hasProducts} />
			{hasProducts && (
				<Products
					products={products}
					filter={filter}
					hideBrands
				/>
			)}
			{news.length > 0 && (
				<>
					<Heading>
						<h2>Articles featuring {title}</h2>
					</Heading>
					<Wrap grid>
						{news.map(post => <NewsCard {...post} />)}
					</Wrap>
				</>
			)}
		</>
	);
}

export async function getStaticProps (ctx) {
	const slug = ctx.params.slug;
	const data = await fetchGql(BRAND_QUERY, { slug }, ctx);

	if (!data)
		return { notFound: true };

	return {
		props: {
			...data,
			products: (await fetchGql(PRODUCTS_QUERY, { brand: slug, category: null }, ctx)).products,
			filter: await fetchGql(FILTER_QUERY, null, ctx),
		},
	};
}

export async function getStaticPaths () {
	const data = await fetchGql(gql`{
        entries (section: "brand") {
            slug
        }
    }`);

	return {
		paths: data?.entries?.map?.(e => ({ params: e })) ?? [],
		fallback: 'blocking',
	};
}
